export const LOAN_AMOUNT_SLIDER_STEP = 1000;
